import { useEffect, useState } from 'react';
import { useTheme } from 'styled-components';
import { Staff } from '../../../2_domain/staff/staff';
import { SearchControlBoxContainer } from '../../core/components/box/boxContainer';
import Column from '../../core/components/box/column';
import Row from '../../core/components/box/row';
import SizedBox from '../../core/components/box/sizedBox';
import { LXLabelSelector } from '../../core/components/buttons/lxSelector';
import LXStaffSelector from '../../core/components/buttons/lxStaffSelector';
import { LXLabelInput } from '../../core/texts/lxInput';
import { LXbody, LXh4 } from '../../core/texts/lxText';

interface TestAddStaffProps {
  receptionist?: Staff;
  attendingPhysician?: Staff;
  memo?: Memo;
  setReceptionist: (staff: Staff) => void;
  setAttendingPhysician: (staff: Staff) => void;
  onMemoChange: (newValue: Memo) => void;
}

const TestAddStaff = (props: TestAddStaffProps) => {
  const theme = useTheme();
  const [staffKind, setStaffKind] = useState<StaffKind | 'All'>('All');
  const [receptionist, setReceptionist] = useState(props.receptionist);
  const [attendingPhysician, setAttendingPhysician] = useState(
    props.attendingPhysician
  );

  useEffect(() => {
    if (receptionist) props.setReceptionist(receptionist);
  }, [props, receptionist]);

  useEffect(() => {
    if (attendingPhysician) props.setAttendingPhysician(attendingPhysician);
  }, [props, attendingPhysician]);

  const header = (
    <Column>
      <LXh4>{theme.staff.selectManager}</LXh4>
      <SizedBox height={4}></SizedBox>
      <LXbody color={theme.colors.caption}>
        {theme.staff.pleaseSelectAManager}
      </LXbody>
    </Column>
  );

  return (
    <Column>
      {header}
      <SizedBox height={24}></SizedBox>
      <SearchControlBoxContainer width="none">
        <Row>
          <LXLabelSelector<StaffKind | 'All'>
            label={theme.texts.managerType}
            value={staffKind}
            values={['All', 'Doctor', 'Nurse', 'Nonmedical Personnel']}
            labels={[
              theme.staff.all,
              theme.staff.doctor,
              theme.staff.nurse,
              theme.staff.manager,
            ]}
            onSelect={setStaffKind}
            dropdownItemWidth={144}
            dropdownHeaderWidth={144}
          ></LXLabelSelector>
          <SizedBox width={8}></SizedBox>
          <LXStaffSelector
            staffKind={staffKind}
            originStaffId={receptionist?.id}
            onSelect={setReceptionist}
            width={200}
          ></LXStaffSelector>
          <SizedBox width={24} />
          <LXStaffSelector
            staffKind={'Doctor'}
            label={theme.staff.attendingPhysician}
            originStaffId={attendingPhysician?.id}
            onSelect={setAttendingPhysician}
            width={200}
          ></LXStaffSelector>
        </Row>
      </SearchControlBoxContainer>
      <SizedBox height={40}></SizedBox>
      <LXLabelInput
        width={636}
        height={200}
        value={props.memo}
        label={`${theme.texts.memo} (${theme.texts.optional})`}
        onChange={props.onMemoChange}
        isMultiline={true}
        placeholder={theme.texts.enterSomethingRelatedToTheClient}
      ></LXLabelInput>
    </Column>
  );
};

export default TestAddStaff;
